import React from 'react'
import styled from 'styled-components'

import { shortDate } from 'helpers/formatters'

import Body from './Body'
import { color } from 'styles/colors'

type Props = React.PropsWithChildren<{
  className?: string
  messageType?: string
}>

type PublishedDateProps = {
  publishedAt: string
}

const SiteMessage = ({
  children,
  messageType,
  className = '',
  ...props
}: Props) => {
  const messageProps = {
    className,
    ...props,
    ...(messageType ? { messageType } : {})
  }

  return <S.SiteMessage {...messageProps}>{children}</S.SiteMessage>
}

SiteMessage.Body = Body
SiteMessage.PublishedDate = ({ publishedAt }: PublishedDateProps) => (<S.PublishedDate>{shortDate(publishedAt)}</S.PublishedDate>)

export default SiteMessage

const S = {
  SiteMessage: styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'messageType'
  })<{ messageType?: string }>`
    width: 100%;
    background-color: ${({ messageType }) =>
    messageType === 'info'
      ? color('siteMessageInfoBackground')
      : messageType === 'warning'
        ? color('siteMessageWarningBackground')
        : 'unset'};
  `,
  PublishedDate: styled.div`
    font-weight: 400;
    font-size: 13px;
  `
}
